import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import Logo from "@assets/img/logo";
import { ROUTES } from "src/router/routes";

export const RedirectAmazon = () => {
  const nav = useNavigate();

  return (
    <div className={styles.page}>
      <Link to={ROUTES.ROOT}>
        <Logo />
      </Link>
      <p className={styles.subtitle}>Connect to your Seller Account</p>

      <h1 className={styles.heading}>
        You will be redirected to <br />
        Amazon Seller page
      </h1>

      <p className={styles.info}>
        To authorize Nyle access to your Seller Partner account.
      </p>

      <p className={styles.note}>
        <span className={styles.link}>Click here</span>{" "}
        <span className={styles.toBlack}>if a new tab hasn't opened</span>
      </p>

      <button
        type="button"
        className={styles.cta}
        onClick={() => nav("/account-success")}
      >
        CLICK HERE →
      </button>
    </div>
  );
};
